import styled from "styled-components";
import {
  Divider,
  Grid
} from "@material-ui/core";
import {
  TextInput,
  DatePicker,
  AutoCompleteInput,
  DecimalInput,
  PercentInput,
  MoneyInput
} from "components/Global/FormikMaterial";

// Styled Grid
export const SectionGrid = styled(Grid)`padding-left:15px; max-width:670px;`;
export const TopParentGrid = styled(Grid)`padding-left:15px; max-width:670px;`;
export const ParentGrid = styled(Grid)`padding-top:40px; padding-left:15px; max-width:670px;`;
export const LastGrid = styled(Grid)`padding-left:15px;`;
export const ButtonBar = styled(Grid)`&& > *:first-child {margin-right: 12px; }`;
export const ModalButtonBar = styled(Grid)`&& { float: right; > *:first-child {margin-right: 12px; }}`;
export const AlignedGrid = styled(Grid)`&& {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    padding: 4px 20px 4px 24px; }`;
export const CenterAlignedGrid = styled(AlignedGrid)`&& { background-color: rgba(249, 249, 249, 1); text-align:center; }`;
export const LeftAlignedGrid = styled(AlignedGrid)`&& { text-align:left; }`;
export const RightAlignedGrid = styled(AlignedGrid)`&& { margin-top:4px; margin-top:4px; text-align:right; }`;

// Styled Formik

export const StyledLabel = styled.div`{
    //styleName: Work Sans / 16 Medium;
    font-family: Work Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
   }`;

export const StyledAutoCompleteInput = styled(AutoCompleteInput)`& {
    color: #5F6368;width:100%; margin-top: 2px;
}`;

export const StyledTextInput = styled(TextInput)`& {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;

    /* Text / Dark Gray */
    color: #5F6368;width:100%; }`;
export const StyledPercentInput = styled(PercentInput)`& {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;

    /* Text / Dark Gray */
    color: #5F6368;width:100%; }`;
export const StyledMoneyInput = styled(MoneyInput)`& {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;

    /* Text / Dark Gray */
    color: #5F6368;width:100%; }`;
export const StyledDecimalInput = styled(DecimalInput)`&&& {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;

    /* Text / Dark Gray */
    color: #5F6368;width:100%; margin-top: 1px; }`;
export const StyledDatePicker = styled(DatePicker)`& {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;

    /* Text / Dark Gray */
    color: #5F6368;
    width:100%; 
}`;

// Styled material-ui
export const FancyDivider = styled(Divider)`&&& { background-color: #d8d8d8; width:100%; margin-bottom:4px; }`;
export const FancyDividerBlack = styled(FancyDivider)`&&& { height:3px; }`;
export const FancyDividerGray = styled(FancyDivider)`&&& { height:1px; }`;

// Styled Div
export const BlueResult = styled.div`align-items:center; background:#DADCE0; color:#000; display:flex; flex-flow: column nowrap; padding:32px;`;
export const CenterAlignedValue = styled.div`&& {
    font-family: Work Sans; 
    font-size:24px !important; 
    text-align:center;
    font-style: normal;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0em;   }`;
export const WhiteBackground = styled.div`text-align:center; background:#fff; width:100%; padding:12px 0; margin-bottom:8px;`;
export const BigText = styled.div`&& {     
    font-family: Work Sans;
    font-size: 36px !important;
    font-style: normal;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0em;    
    margin:8px 0;  }`;
export const Label = styled.div`
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;   
    text-transform:uppercase;
    font-size:13px !important;`;
export const PrimaryDataWrapper = styled.div`display:flex; flex-flow:column nowrap; width:100%; align-items: center;`;
export const AddRow = styled.div`display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: center;`;
export const CenteredVerticalSpace = styled.div`text-align:center; margin-top:4px; margin-bottom:4px;`;
export const AdditionalInformationWrapper = styled.div`&& { margin-top: 15px; text-align:left; width: 100%; }`;
export const FlexContainer = styled.div`display:flex; flex-flow:column nowrap; justify-content:center; align-items:center;`;
export const CenterAlignedLabel = styled(Label)`&&{    
    font-family: Work Sans;    
    font-style: normal;    
    line-height: 23px;
    letter-spacing: 0em;  
    text-align:center; }`;
export const PercentContainer = styled.div`&& { margin-top: 15px; text-align:left; width: 100%; }`;
export const ParentGridContainer = styled.div`&& { margin: 0;}`;
export const ResultsGridContainer = styled.div`&& { width: 570px;}`;
export const ResultErrorContainer = styled.div`&& {font-size:24px !important; text-align:center; }`;
